import React, { useEffect, useRef, useState } from "react";
import styles from "./style.scss";
import { DownloadType } from "models/AiResearch";
import { OutlineButton } from "components/Common/Button/Outline";

interface Props {
  onClickPulldownItem: (type: DownloadType) => void;
  disabled: boolean;
}

export const DownloadButton: React.FC<Props> = ({
  onClickPulldownItem,
  disabled
}) => {
  const [showDownloadPulldown, setShowDownloadPulldown] = useState(false);

  const downloadPulldownRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const isNode = (target: EventTarget | null): target is Node =>
      Boolean(target && (target as Node).nodeType);

    const handleClickOutside = (event: MouseEvent) => {
      const pulldownNode = downloadPulldownRef.current as {
        contains: (node: Node | null) => boolean;
      } | null;

      if (
        pulldownNode &&
        isNode(event.target) &&
        !pulldownNode.contains(event.target)
      ) {
        setShowDownloadPulldown(false);
      }
    };

    window.addEventListener("click", handleClickOutside);

    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <span ref={downloadPulldownRef} className={styles.downloadPulldown}>
      <OutlineButton
        className={styles.button}
        onClick={() => setShowDownloadPulldown(!showDownloadPulldown)}
        disabled={disabled}
      >
        <span className={styles.downloadImage} />
        ダウンロード
      </OutlineButton>

      {showDownloadPulldown && (
        <ul className={styles.pulldownMenu}>
          <li onClick={() => onClickPulldownItem("md")}>Markdown(.md)</li>
          <li onClick={() => onClickPulldownItem("pdf")}>PDF文書(.pdf)</li>
          <li onClick={() => onClickPulldownItem("docx")}>
            Microsoft Word(.docx)
          </li>
        </ul>
      )}
    </span>
  );
};
